import React from 'react';
import T from 'prop-types';

import Container from '../../../../components/Container';

const SectionDivider = ({ disableGutters = false }) => (
  <Container disableGutters={disableGutters} maxWidth={1248}>
    <hr className="section-divider" />
  </Container>
);

SectionDivider.propTypes = {
  disableGutters: T.bool,
};

export default SectionDivider;
